import { Routes } from '@angular/router';

import { AppGuard } from '../../app/guard/app/app.guard';
import { AuthGuard } from '../../app/guard/auth/auth.guard';

export const auditorSpedRoutes: Routes = [
  {
    path: 'auditor-sped',
    title: 'Auditor SPED | ITC Digital',
    loadComponent: () =>
      import('./home/auditor-sped.component').then(m => m.AuditorSpedComponent),
    canActivate: [AuthGuard, AppGuard],
    data: { appId: 8 },
    children: [
      {
        path: '',
        title: 'Auditor SPED | ITC Digital',
        loadComponent: () =>
          import('./components/auditor-dashboard/auditor-dashboard.component').then(m => m.AuditorDashboardComponent),
        canActivate: [AuthGuard, AppGuard],
        data: { appId: 8 }
      }
    ]
  }
];